import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { VerifiedBadge } from "./VerifiedBadge";
import { mediaUrl } from "../lib/mediaUrl";

export const PhotographerCard = ({ photographer }) => (
  <div data-testid={`photographer-card-${photographer.id}`} className="bg-clean-white border border-soft-gray rounded-2xl p-6 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300">
    <img src={mediaUrl(photographer.profile_photo_url)} alt={photographer.business_name} className="w-24 h-24 rounded-full object-cover mb-4 border-2 border-stranger-orange" />
    <h3 className="font-extrabold uppercase tracking-tight text-lg mb-1">{photographer.business_name}</h3>
    <p className="text-sm text-midnight-black/60 mb-3 flex items-center gap-1 justify-center">
      <MapPin className="w-3.5 h-3.5 text-stranger-orange" /> {photographer.location}
    </p>
    {photographer.verified && (
      <div className="mb-4">
        <VerifiedBadge compact />
      </div>
    )}
    <Link to={`/photographers/${photographer.slug || photographer.id}`} data-testid={`view-photographer-${photographer.id}`} className="mt-auto">
      <button className="text-xs font-bold tracking-widest border-2 border-midnight-black px-6 py-3 rounded-full hover:bg-midnight-black hover:text-clean-white transition-colors">VIEW PROFILE</button>
    </Link>
  </div>
);
